<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {disruptionApi} from "@/container";
import DisruptionPartnerItem from "@/disruption-logistics/components/disruption-partners/DisruptionPartnerItem.vue";
import {Skeleton} from "@/core/components/ui/skeleton";

const {data, isLoading} = useSwr(
    "/disruptions/partners",
    () => disruptionApi().partners()
);
</script>

<template>
  <div v-if="isLoading || (data ?? []).length > 0" class="space-y-2">
    <h1>Vos partenaires sont là pour vous aider</h1>
    <div v-if="isLoading" class="flex gap-6">
      <div
        v-for="(skeleton) in 2"
        :key="skeleton"
        class="border-[1.5px] p-4 border-primary rounded-lg bg-white w-[240px] flex gap-4"
      >
        <Skeleton class="h-12 w-12" />
        <Skeleton class="h-4 w-full" />
      </div>
    </div>
    <div v-else class="flex gap-6 flex-wrap">
      <DisruptionPartnerItem
        v-for="organization in data ?? []"
        :key="organization.id"
        :partner-name="organization.morphable?.name"
        :branding="organization.morphable?.branding"
        :alert="organization.morphable?.disruptionAlert"
        :partnership-types="organization.partnershipTypes"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
